import { api } from './client'

// Tipurile de eveniment emise azi de backend (DowntimeEventType.For, OrdineProductieController) — FR-OPE-032/033.
export const DOWNTIME_CAUSES = [
  'DefectiuneMecanica', 'LipsaMaterial', 'SchimbMatrita', 'Pauza', 'Curatare', 'LipsaUtilitate', 'Altele',
] as const
export type DowntimeCause = (typeof DOWNTIME_CAUSES)[number]
export const downtimeEventType = (cause: DowntimeCause) => `ProductieOprire.${cause}`

export interface NotificationRule {
  id: string; eventType: string; roleId: string; roleName: string; notifyInApp: boolean; notifyEmail: boolean
  escalationThresholdMinutes: number | null; escalationRoleId: string | null; escalationRoleName: string | null
  isActive: boolean
}

export interface SaveNotificationRulePayload {
  eventType: string; roleId: string; notifyInApp: boolean; notifyEmail: boolean
  escalationThresholdMinutes: number | null; escalationRoleId: string | null
}

export const listNotificationRules = () => api.get<NotificationRule[]>('/admin/reguli-notificare').then((r) => r.data)
export const createNotificationRule = (payload: SaveNotificationRulePayload) =>
  api.post<{ id: string }>('/admin/reguli-notificare', payload).then((r) => r.data)
export const updateNotificationRule = (id: string, payload: SaveNotificationRulePayload) =>
  api.put(`/admin/reguli-notificare/${id}`, payload)
export const deactivateNotificationRule = (id: string) => api.post(`/admin/reguli-notificare/${id}/dezactiveaza`)
export const reactivateNotificationRule = (id: string) => api.post(`/admin/reguli-notificare/${id}/activeaza`)
